import { GetCompanyReviewFormResponseJson, GetCompanyReviewFormsResponse } from "@performyard/service-contracts";

import { PYUseQueryOptions } from "../../hooks/StandardQueryArguments";

import { getCompanyEngagementSettings, getCompanySettings } from "../../services";
import { getCompanyFormByBaseId, getCompanyForms } from "../../services/defs/internal-api";

export const companySettingsQuery = () => ({
	queryKey: ["company-settings"],
	queryFn: () => getCompanySettings(),
	meta: {
		errorMessage: "There was an error getting the company settings.",
	},
});

export const companyEngagementSettingsQuery = () => ({
	queryKey: [`companyEngagementSettings`],
	queryFn: () => getCompanyEngagementSettings(),
	meta: {
		errorMessage: "There was an error getting the company engagement settings.",
	},
});

export const useCompanyFormsQuery = (
	searchOptions: { search?: string; sort?: string; direction?: string; page?: number; limit?: number },
	options?: PYUseQueryOptions<GetCompanyReviewFormsResponse>
) => ({
	queryKey: ["company-forms", searchOptions],
	queryFn: () => getCompanyForms(searchOptions),
	meta: {
		errorMessage: "Error getting company Forms",
	},
	...options,
});

export const useCompanyFormQuery = (baseId: string, options?: PYUseQueryOptions<GetCompanyReviewFormResponseJson>) => ({
	queryKey: ["company-form", baseId],
	queryFn: () => getCompanyFormByBaseId(baseId),
	meta: {
		errorMessage: "Error getting the form",
	},
	...options,
});
